var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('exportView',{ref:"exportView",attrs:{"tab-options":_vm.tabOptions,"tipContent":_vm.$t('Root.Export.page_notice')}})}
var staticRenderFns = []

export { render, staticRenderFns }